<table class="table table-centered table-nowrap">
    <thead>
        <th>
            {{'Common.Date'|translate}}
        </th>
        <th>
            {{'Common.Visa'|translate}}
        </th>
        <!-- <th>
            {{'Common.TrxRef'|translate}}
        </th> -->
        <!-- <th>
            {{'Common.From'|translate}}
        </th> -->
        <th>
            {{'Common.To'|translate}}
        </th>
        <th>
            {{'Common.Phone'|translate}}
        </th>
        <th>
            {{'Common.PaymentType'|translate}}
        </th>
        <th>
            {{'Common.BalanceBeforeTrans'|translate}}
        </th>
        <th>
            {{'Common.Amount2'|translate}}
        </th>
        <!-- <th>الضريبه</th> -->
        <th>
            {{'Common.TransferedAmount'|translate}}
        </th>
        @if(!isPrinting){
            <th class="text-center"> {{'Common.Actions'|translate}}</th>
        }@else {
            <th>{{'Common.Vat'|translate}}</th>
            <th>{{'Common.Commission'|translate}}</th>
        }
    </thead>
    <tbody>
        <tr *ngFor="let transaction of dataSource">
            <td>
                {{ transaction.TransferDate | date: 'dd/MM/yyyy - hh:mm a' }}
            </td>
            <td>
                {{ transaction.CardNumber}}
            </td>
            <!-- <td>
                {{ transaction.MerchantReference.substring(0,8)}}...
                @if(!isPrinting){
                    <a (click)="showMore(transaction.MerchantReference)" class="showMore">
                        {{'Common.More'|translate}}
                    </a>
                }
            </td> -->
            <!-- <td>
                {{ transaction.FromUserName }}
            </td> -->
            <td>
                {{ transaction.ToUserName }}
            </td>
            <td>
                {{ transaction.ToUser }}
            </td>
            <td>
                <span>
                    {{ ('Common.'+ reportPayTypeEnum[transaction.PaymentMethod] |translate) }}
                </span>
            </td>
            <td>
                {{ transaction.BalanceBefore }}
            </td>
            <td [ngStyle]="{'min-width': isPrinting ? '' :'100px'}">
                {{ transaction.Total }}
            </td>
            <!-- <td>{{ transaction.Vat }}</td> -->
            <td [ngStyle]="{'min-width': isPrinting ? '' :'120px'}">
                {{ transaction.TransferedBalance }}
            </td>
            @if(!isPrinting){
                <td [ngStyle]="{'min-width': isPrinting ? '' :'150px'}">
                    <div class="d-flex table-actions-column">
                        <app-text-button class="action-button" [label]="'Common.PayDetails'" [lucidePrefixIcon]="'hand-coins'" (handleClick)="showTransactionPayDetails(transaction)" > </app-text-button>
                    </div>
                </td>
            }@else {
                <td>{{transaction.Vat}}</td>
                <td>{{transaction.BankCommission}}</td>
            }
        </tr>
    </tbody>
</table>